import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";

const SEO_TITLE = "Geen toegang";

const Unauthorized = () => {
  return (
    <Main>
      <MetaData title={SEO_TITLE} />
      <p>Je hebt geen toegang tot deze pagina</p>
    </Main>
  );
};

export default Unauthorized;
